import { render, staticRenderFns } from "./PriceNow.vue?vue&type=template&id=a01b575a&scoped=true&"
import script from "./PriceNow.vue?vue&type=script&lang=js&"
export * from "./PriceNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01b575a",
  null
  
)

export default component.exports